import { render, staticRenderFns } from "./NuevoCierre.vue?vue&type=template&id=206b5d92"
import script from "./NuevoCierre.vue?vue&type=script&lang=js"
export * from "./NuevoCierre.vue?vue&type=script&lang=js"
import style0 from "./NuevoCierre.vue?vue&type=style&index=0&id=206b5d92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports